import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GeolocationPositionError } from '../geolocation-position-error.interface';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'forms-no-geolocation-dialog',
  templateUrl: './no-geolocation-dialog.component.html',
  })
export class GeolocalizationDialogComponent implements OnInit {
  message: string = '';

  constructor(
    public platform: Platform,
    private dialogRef: MatDialogRef<GeolocalizationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: GeolocationPositionError,
  ) {}

  ngOnInit(): void {
    switch (this.data.code) {
      case this.data.PERMISSION_DENIED:
        this.message = 'Nie udało się ustalić lokalizacji. Aplikacja nie posiada uprawnień dostępu do lokalizacji. Nadaj je i spróbuj ponownie';
        break;
      case this.data.POSITION_UNAVAILABLE:
        this.message = 'Nie udało się ustalić lokalizacji. Sprawdź, czy usługi lokalizacyjne są włączone i spróbuj ponownie';
        break;
      case this.data.TIMEOUT:
        this.message = 'Nie udało się ustalić lokalizacji w żądanym czasie. Spróbuj ponownie';
        break;
      default:
        this.message = 'Nie udało się ustalić lokalizacji. Urządzenie nie posiada modułu geolokacji';
    }
  }

  close(retry: boolean): void {
    this.dialogRef.close(retry);
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/components/controls/localization/no-geolocation-dialog/no-geolocation-dialog.component.ts